import { whiteColor } from "@config"
import createPage from "@src/components/page"
import React from "react"
import * as styles from "./pageLiked.module.scss"

import d1Img from "@images/png/18.png"
import Numbers from "@src/components/numbers"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { animated } from "@react-spring/web"

const parseData = ({
  attributes: {
    "bookmarked-count": bookmarked,
    "liked-count": liked,
    "shared-count": shared,
  },
}) => ({
  bookmarked,
  liked,
  shared,
})

const PageLiked = createPage(
  ({ data, offset }) => {
    const { bookmarked, liked, shared } = parseData(data)
    const anime1Styles = useEnteringTrail(4, offset)
    const anime2Styles = useEnteringTrail(1, offset, { step: 0.4, type: "mlt" })
    return (
      <>
        <div>
          <animated.img
            style={anime2Styles[0]}
            src={d1Img}
            className={styles.d1}
            alt="d"
          />
        </div>
        <animated.div style={anime1Styles[0]}>发布内容</animated.div>
        {liked > 0 && (
          <animated.div className={styles.flexTop} style={anime1Styles[0]}>
            被点赞
            <Numbers>{liked}</Numbers>次
          </animated.div>
        )}
        {shared > 0 && (
          <animated.div className={styles.flexTop} style={anime1Styles[1]}>
            被分享
            <Numbers>{shared}</Numbers>次
          </animated.div>
        )}
        {bookmarked > 0 && (
          <animated.div className={styles.flexTop} style={anime1Styles[2]}>
            被收藏
            <Numbers>{bookmarked}</Numbers>次
          </animated.div>
        )}
        <animated.div style={anime1Styles[3]} className={styles.thanks}>
          感谢{callYou(data)}对机核的信任与喜爱
        </animated.div>
      </>
    )
  },
  {
    className: styles.page,
  }
)

export const pageLikedData = {
  key: "liked",
  bg: whiteColor,
  Page: PageLiked,
  shouldHide: (data) => {
    const { bookmarked, liked, shared } = parseData(data)
    return bookmarked === 0 && liked === 0 && shared === 0
  },
}

PageLiked.displayName = "PageLiked"
export default PageLiked
